module.exports = __webpack_public_path__ + "h5/img/open-ball2.34b4c8e7.png";